import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Link } from "react-router-dom"

import Icon, { IconTypes } from "components/Icon/Icon"

import FormatterHelper from "helpers/formatter"

import styles from "./pagination.css"

export default class Pagination extends Component {
  static propTypes = {
    currentPage: PropTypes.number,
    route: PropTypes.string.isRequired,
    routeParams: PropTypes.object,
    section: PropTypes.object.isRequired,
  }

  static defaultProps = {
    currentPage: 0,
    routeParams: {},
  }

  getPagesToDisplay() {
    const currentPage = this.props.currentPage
    const pages = []
    const start = Math.floor((currentPage + 1) / 10) * 10 - 1

    for (let i = start; pages.length < 10 && i < this.props.section.getNumberOfPages(); i++) {
      i > -1 && pages.push({ index: i })
    }

    return pages
  }

  getSubLinksToDisplay(range, displayAll = false) {
    const currentPage = this.props.currentPage + 1
    const links = []
    const startIndex = displayAll ? 0 : Math.floor(currentPage / (range * 10)) * range * 10
    let maxPage = displayAll ? this.props.section.getNumberOfPages() - 1 : Math.floor(currentPage / (range * 10)) * range * 10 + range * 10

    if (maxPage > this.props.section.getNumberOfPages()) {
      maxPage = this.props.section.getNumberOfPages()
    }

    for (let i = startIndex; i <= maxPage; i += range) {
      i > 0 && links.push(i)
    }

    return links
  }

  getLink(page) {
    return FormatterHelper.basic(this.props.route, {
      ...this.props.routeParams,
      page,
    })
  }

  render() {
    const currentPage = this.props.currentPage
    const { section } = this.props

    return (
      <div className={styles.root}>
        <div>
          {currentPage === 0 ? (
            <span className={classNames(styles.button, styles.prev, styles.buttonDisabled)}>
              <Icon type={IconTypes.arrowLeft} rootStyle={classNames(styles.arrow)} iconStyle={styles.arrowIcon} />
            </span>
          ) : (
            <Link to={this.getLink(currentPage)} className={classNames(styles.button, styles.prev, { [styles.buttonDisabled]: currentPage === 0 })}>
              <Icon type={IconTypes.arrowLeft} rootStyle={classNames(styles.arrow)} iconStyle={styles.arrowIcon} />
            </Link>
          )}
          {this.getPagesToDisplay().map(page => {
            const props = {
              className: classNames(styles.page, { [styles.currentPage]: page.index === currentPage }),
              key: page.index,
            }

            if (page.index === currentPage) {
              return <div {...props}>{page.index + 1}</div>
            } else {
              return (
                <Link to={this.getLink(page.index + 1)} {...props}>
                  {page.index + 1}
                </Link>
              )
            }
          })}
          {currentPage !== section.getNumberOfPages() - 1 ? (
            <Link to={this.getLink(currentPage + 2)} className={classNames(styles.button, styles.next)}>
              <Icon type={IconTypes.arrowLeft} rootStyle={classNames(styles.arrow, styles.arrowRight)} iconStyle={styles.arrowIcon} />
            </Link>
          ) : (
            <span className={classNames(styles.button, styles.next, styles.buttonDisabled)}>
              <Icon type={IconTypes.arrowLeft} rootStyle={classNames(styles.arrow, styles.arrowRight)} iconStyle={styles.arrowIcon} />
            </span>
          )}
        </div>
        <div>
          {section.getNumberOfPages() > 10 && (
            <div className={styles.subPagination}>
              {this.getSubLinksToDisplay(10).map(page => (
                <Link className={styles.subLink} to={this.getLink(page)} key={page}>
                  {page}+
                </Link>
              ))}
            </div>
          )}
        </div>
        {section.getNumberOfPages() > 100 && (
          <div>
            <div className={styles.subPagination}>
              {this.getSubLinksToDisplay(100, true).map(page => (
                <Link className={styles.subLink} to={this.getLink(page)} key={page}>
                  {page}-{page + 100}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}
